import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
/**
 * @internal
 */

/**
 * @internal
 */

export default class ExportRegistry {
  constructor() {
    _defineProperty(this, "moduleExports", new Map());
    _defineProperty(this, "onLoads", new Map());
    _defineProperty(this, "chunks", new Map());
    _defineProperty(this, "chunkModules", new Map());
    _defineProperty(this, "_revisions", null);
    _defineProperty(this, "_webpack_runtimes", {
      // @ts-ignore
      core: window.testing ? null : __webpack_require__
    });
  }
  add(namespace, id, object) {
    var _this$moduleExports$g, _this$onLoads$get;
    this.moduleExports.set(namespace, this.moduleExports.get(namespace) || new Map());
    (_this$moduleExports$g = this.moduleExports.get(namespace)) == null || _this$moduleExports$g.set(id, object);
    (_this$onLoads$get = this.onLoads.get(namespace)) == null || (_this$onLoads$get = _this$onLoads$get.get(id)) == null || _this$onLoads$get.forEach(handler => handler(object));
  }
  onLoad(namespace, id, handler) {
    var _this$moduleExports$g2;
    if (this.moduleExports.has(namespace) && (_this$moduleExports$g2 = this.moduleExports.get(namespace)) != null && _this$moduleExports$g2.has(id)) {
      var _this$moduleExports$g3;
      handler((_this$moduleExports$g3 = this.moduleExports.get(namespace)) == null ? void 0 : _this$moduleExports$g3.get(id));
    } else {
      var _this$onLoads$get2, _this$onLoads$get3, _this$onLoads$get4;
      this.onLoads.set(namespace, this.onLoads.get(namespace) || new Map());
      (_this$onLoads$get2 = this.onLoads.get(namespace)) == null || _this$onLoads$get2.set(id, ((_this$onLoads$get3 = this.onLoads.get(namespace)) == null ? void 0 : _this$onLoads$get3.get(id)) || []);
      (_this$onLoads$get4 = this.onLoads.get(namespace)) == null || (_this$onLoads$get4 = _this$onLoads$get4.get(id)) == null || _this$onLoads$get4.push(handler);
    }
  }
  get(namespace, id) {
    var _this$moduleExports$g4;
    const module = (_this$moduleExports$g4 = this.moduleExports.get(namespace)) == null ? void 0 : _this$moduleExports$g4.get(id);
    const extensionEnabled = namespace in flarum.extensions || namespace === 'core';
    const error = "No module found for ".concat(namespace, ":").concat(id);

    // Check if the module is registered in a chunk (will be loaded lazily)
    const isInChunk = this.chunkModules.has("".concat(namespace, ":").concat(id));

    // @ts-ignore
    if (!module && extensionEnabled && !isInChunk && flarum.debug) {
      throw new Error(error);
    } else if (!module && extensionEnabled && !isInChunk) {
      console.warn(error);
    }
    return module;
  }
  checkModule(namespace, id) {
    var _this$moduleExports$g5;
    const exists = this.moduleExports.has(namespace) && ((_this$moduleExports$g5 = this.moduleExports.get(namespace)) == null ? void 0 : _this$moduleExports$g5.has(id)) || false;
    return exists ? this.get(namespace, id) : false;
  }
  addChunkModule(chunkId, moduleId, namespace, urlPath) {
    if (!this.chunks.has(chunkId.toString())) {
      this.chunks.set(chunkId.toString(), {
        namespace,
        urlPath,
        modules: [urlPath]
      });
    } else {
      var _this$chunks$get;
      (_this$chunks$get = this.chunks.get(chunkId.toString())) == null || (_this$chunks$get = _this$chunks$get.modules) == null || _this$chunks$get.push(urlPath);
    }
    this.chunkModules.set("".concat(namespace, ":").concat(urlPath), {
      chunkId: chunkId.toString(),
      moduleId: moduleId.toString()
    });
  }
  getChunk(chunkId) {
    var _this$chunks$get2;
    const chunk = (_this$chunks$get2 = this.chunks.get(chunkId.toString())) != null ? _this$chunks$get2 : null;
    if (!chunk) {
      console.warn("[Export Registry] No chunk by the ID ".concat(chunkId, " found."));
      return null;
    }
    return chunk;
  }
  async loadChunk(original, url, done, key, chunkId) {
    // @ts-ignore
    app.alerts.showLoading();
    const chunkUrl = this.chunkUrl(chunkId) || url;
    const load = () => original(chunkUrl, function () {
      const event = arguments.length <= 0 ? undefined : arguments[0];

      // A chunk that failed to load because the browser is offline is
      // retried once connectivity is restored. Its import() promise stays
      // pending in the meantime, so every caller awaiting the chunk
      // recovers on its own — mirroring how `Application#request` defers
      // GET requests that fail while offline.
      if ((event == null ? void 0 : event.type) === 'error' && navigator.onLine === false) {
        const retry = () => {
          window.removeEventListener('online', retry);
          load();
        };
        window.addEventListener('online', retry);
        return;
      }

      // @ts-ignore
      app.alerts.clearLoading();
      return done(...arguments);
    }, key, chunkId);
    return await load();
  }
  chunkUrl(chunkId) {
    var _this$_revisions, _document$getElementB, _document$getElementB2;
    const chunk = this.getChunk(chunkId.toString());
    if (!chunk) return null;
    (_this$_revisions = this._revisions) != null ? _this$_revisions : this._revisions = JSON.parse((_document$getElementB = (_document$getElementB2 = document.getElementById('flarum-rev-manifest')) == null ? void 0 : _document$getElementB2.textContent) != null ? _document$getElementB : '{}');

    // @ts-ignore cannot import the app object here, so we use the global one.
    const path = "".concat(app.forum.attribute('jsChunksBaseUrl'), "/").concat(chunk.namespace, "/").concat(chunk.urlPath, ".js");

    // The paths in the revision are stored as (relative path from the assets path) + the path.
    // @ts-ignore
    const assetsPath = app.forum.attribute('assetsBaseUrl');
    const key = path.replace(assetsPath, '').replace(/^\//, '');
    const revision = this._revisions[key];
    return revision ? "".concat(path, "?v=").concat(revision) : path;
  }
  async asyncModuleImport(path) {
    var _this$_webpack_runtim;
    const [namespace, id] = this.namespaceAndIdFromPath(path);
    const module = this.chunkModules.get("".concat(namespace, ":").concat(id));
    if (!module) {
      throw new Error("No chunk found for module ".concat(namespace, ":").concat(id));
    }

    // @ts-ignore
    const wr = (_this$_webpack_runtim = this._webpack_runtimes[namespace]) != null ? _this$_webpack_runtim : __webpack_require__;
    return await wr.e(module.chunkId).then(wr.bind(wr, module.moduleId)).then(() => {
      var _m$default;
      const m = this.get(namespace, id);
      (_m$default = m.default) != null ? _m$default : m.default = m;
      return m;
    });
  }
  clear() {
    this.moduleExports.clear();
    this.onLoads.clear();
    this.chunks.clear();
    this.chunkModules.clear();
  }
  namespaceAndIdFromPath(path) {
    // Either we get a path like `flarum/forum/components/LogInModal` or `ext:flarum/tags/forum/components/TagPage`.
    const matches = /^(?:ext:([^\/]+)\/(?:flarum-(?:ext-)?)?([^\/]+)|(flarum))(?:\/(.+))?$/.exec(path);
    const id = matches[4];
    let namespace;
    if (matches[1]) {
      namespace = "".concat(matches[1], "-").concat(matches[2]);
    } else {
      namespace = 'core';
    }
    return [namespace, id];
  }
}